import validateForm from './../../../_global/js/components/validateForm';



/*
 * barba view
 */
const Contact = {
  namespace: 'contact',
  afterEnter: (data) => {
    let formsToValidate = document.querySelectorAll('form[data-validate]');
    formsToValidate.forEach(form => validateForm(form, {
    	showErrors: false,
    }));
  }
}

export default Contact;
